import React from 'react';
import { componentService } from 'js/services/component.service';

export const SessionTicker = React.lazy(() => import(/* webpackChunkName: "session-ticker" */ './SessionTicker'));

// <hub2-session-ticker></hub2-session-ticker>
componentService.registerWebContentComponents({ SessionTicker });
